/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Auth from "../../shared/Auth";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import './Dashboard.css';
import Globals from "../../shared/Globals";
import GaugeChart from 'react-gauge-chart';
import { qreq } from "../../shared/qrequest";
import { CardPrimary } from "./NewDashboard";
import InvoiceSalesChart from "../chart/InvoiceSalesChart";
import L from "../Lang";


class MnfDashboard extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            user: null
        };
    }

    async componentDidMount() {
        Auth.getLogin(u => {
            this.setState({ user: u });
        });
        await this.getSettings();
        await this.getMainOrg();
        await this.loadProducts();

    }

    loadProducts = async () => {
        try {

            let j = await qreq.getAsync('/api/product/list');
            if (j.list) {
                this.setState({ productList: j.list });
                await this.loadStock(j.list);
            }
        }
        catch (e) {

        }
    }

    loadStock = async (products) => {
        try {

            let j = await qreq.getAsync('/api/inventory/instock');
            if (j.list) {
                this.setState({ stockList: j.list });
                this.processList(products, j.list);
            }
        }
        catch (e) {

        }
    }

    processList = (productList, stockList) => {
        productList.forEach(p => {
            let find = stockList.find(x => x.productID === p.id);
            if (find)
                p.inStock = find.counter;
            else
                p.inStock = 0;
            p.__percent = parseFloat(p.inStock / p.lowStockAlarmThresh);
            if (p.__percent > 1)
                p.__percent = 1;
        });
        this.setState({ productList });
    }

    render() {
        return <div className="Dashboard dashboard-redesign container-fluid">
            <h1 className="d-none"><L>DASHBOARD</L></h1>
            <header className="dashboard-welcome">
                <div className="dashboard-eyebrow"><L>Dashboard</L></div>
                <div className="dashboard-greeting" role="heading" aria-level="1">
                    <L>{Globals.getTimeOfDay('Good ')}</L>{this.state.user?.name ? `, ${this.state.user.name}` : ''}.
                </div>
                <p><L>Your workspace at a glance.</L></p>
            </header>

            {Auth.hasRole('admin') && <div className="mt-3">
                <CardPrimary title={<L>Total Sales</L>}>
                    <InvoiceSalesChart />
                </CardPrimary>
            </div>}

            {Auth.hasRole('manager') && <section className="mt-3" aria-label="Inventory">
                <CardPrimary title={<L>Inventory Levels</L>}>
                    {!this.state.productList && <div className="dashboard-widget-state" role="status"><L>Loading inventory…</L></div>}
                    {this.state.productList && !this.state.productList.some(p => p.lowStockAlarm) &&
                        <div className="dashboard-widget-state"><L>No stock alerts configured.</L></div>}
                    <div className="row g-3">
                        {this.state.productList?.filter(x => x.lowStockAlarm).map((p, pdx) => (
                            <div className="col-12 col-sm-6 col-xl-3 text-center" key={p.id ?? pdx}>
                                <div className="h-100 border rounded-3 p-3" style={{ background: '#f6f9fc' }}>
                                    <div className="fw-semibold mb-3" style={{ color: 'var(--dash-ink)', overflowWrap: 'anywhere' }}>{p.nameWithSize}</div>
                                    <GaugeChart
                                        id={`inventory-gauge-${p.id ?? pdx}`}
                                        nrOfLevels={p.lowStockAlarmThresh}
                                        percent={p.__percent || 0}
                                        arcPadding={0.02}
                                        needleColor={this.state.org?.primaryColor}
                                        arcsLength={[0.1, 0.9]}
                                        colors={['#b82929ff', '#32ad32ff']}
                                        hideText
                                    />
                                    <div className="mt-2 fw-semibold" style={{ color: 'var(--dash-blue)', fontVariantNumeric: 'tabular-nums' }}>
                                        {p.inStock || '0'}<span className="text-muted fw-normal"> / {p.lowStockAlarmThresh}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </CardPrimary>
            </section>}

        </div>
    }
}

export default withParamsAndNavigate(MnfDashboard);
